<template>
  <v-navigation-drawer
    app
    permanent
    class="common-sidebar"
    :mini-variant="!expand"
    mini-variant-width="64"
    width="256"
    color="#16181F"
  >
    <template #prepend>
      <div class="common-sidebar__prepend">
        <v-icon color="white" class="pointer" @click="expand = !expand">
          {{ !expand ? 'mdi-chevron-right' : 'mdi-chevron-left' }}
        </v-icon>
      </div>
    </template>

    <v-list dense>
      <v-list-item-group>
        <v-list-item
          v-for="(item, i) in sidebarItems.filter(item => item.show === true && !item.disabled)"
          :class="{ 'v-list-item--active': $route.name === item.url.name }"
          class="justify-center rounded-0 tooltip px-5"
          :disabled="item.disabled"
          :to="item.href ? null : item.url"
          :href="item.href"
          :key="i"
          link
        >
          <v-tooltip right nudge-right="11" :disabled="expand">
            <template #activator="{ on, attrs }">
              <div class="d-flex" style="width: 100%; height: 57px" v-bind="attrs" v-on="on">
                <v-list-item-icon>
                  <component :is="item.icon" :width="25" :height="25" />
                </v-list-item-icon>
                <v-list-item-content>
                  {{ item.name }}
                </v-list-item-content>
              </div>
            </template>
            <span>
              {{ item.tooltip }}
            </span>
          </v-tooltip>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <template #append>
      <div class="common-sidebar__append">
        <v-menu
          max-width="160"
          open-on-click
          offset-x
          bottom
          right
          z-index="10"
          :nudge-left="expand ? 24 : 12"
          content-class="common-menu__content"
        >
          <template #activator="{ on, attrs }">
            <v-list-item
              class="common-sidebar__append-item"
              v-bind="attrs"
              v-on="on"
            >
              <v-tooltip right nudge-right="11" :disabled="expand">
                <template #activator="{ on, attrs }">
                  <div class="d-flex" style="width: 100%; height: 57px" v-bind="attrs" v-on="on">
                    <v-list-item-icon>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 29 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M14.8719 19.0004C14.3021 19.0004 13.8406 19.4619 13.8406 20.0317C13.8406 20.6015 14.3021 21.0641 14.8719 21.0641C15.4417 21.0641 15.9032 20.6015 15.9032 20.0317C15.9032 19.4619 15.4417 19.0004 14.8719 19.0004M14.8721 8.16643C12.7445 8.16643 11.0026 9.90836 11.0026 12.0359C10.9972 12.4628 11.3384 12.8148 11.7663 12.8202C12.1931 12.8267 12.5441 12.4855 12.5506 12.0576C12.5506 12.05 12.5506 12.0435 12.5506 12.0359C12.5506 10.7447 13.5808 9.71445 14.8721 9.71445C16.1634 9.71445 17.1936 10.7447 17.1936 12.0359C17.1936 12.8387 16.8697 13.3868 16.3389 13.9458C15.808 14.5058 15.0725 15.0117 14.3889 15.5588C14.2048 15.705 14.0986 15.9282 14.0986 16.1633V17.1946C14.0921 17.6225 14.4334 17.9734 14.8613 17.9799C15.2881 17.9854 15.6401 17.6441 15.6456 17.2162C15.6456 17.2097 15.6456 17.2021 15.6456 17.1946V16.5413C16.2099 16.1113 16.8718 15.6379 17.4676 15.0107C18.162 14.2783 18.7416 13.2915 18.7416 12.0359C18.7416 9.90836 16.9997 8.16643 14.8721 8.16643M14.8718 4.55582C20.4367 4.55582 24.9313 9.05039 24.9313 14.6152C24.9313 20.1801 20.4367 24.6747 14.8718 24.6747C9.30698 24.6747 4.81242 20.1801 4.81242 14.6152C4.81242 9.05039 9.30698 4.55582 14.8718 4.55582M14.8721 3.00781C8.47094 3.00781 3.26465 8.2141 3.26465 14.6153C3.26465 21.0164 8.47094 26.2227 14.8721 26.2227C21.2732 26.2227 26.4795 21.0164 26.4795 14.6153C26.4795 8.2141 21.2732 3.00781 14.8721 3.00781"
                          fill="white"
                        />
                      </svg>
                    </v-list-item-icon>
                    <v-list-item-content>
                      Help
                    </v-list-item-content>
                  </div>
                </template>
                <span>
                  Help
                </span>
              </v-tooltip>
            </v-list-item>
          </template>

          <v-list>
            <v-list-item
              :ripple="false"
              target="_blank"
              href="https://corporategift.com/faq"
            >
              <v-list-item-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <mask id="mask0_8395_65564" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_8395_65564)">
                    <path d="M13.7499 14.7692C13.9948 14.7692 14.2086 14.6779 14.3913 14.4952C14.574 14.3125 14.6653 14.0987 14.6653 13.8538C14.6653 13.6089 14.574 13.3952 14.3913 13.2125C14.2086 13.0298 13.9948 12.9385 13.7499 12.9385C13.5051 12.9385 13.2913 13.0298 13.1086 13.2125C12.9259 13.3952 12.8345 13.6089 12.8345 13.8538C12.8345 14.0987 12.9259 14.3125 13.1086 14.4952C13.2913 14.6779 13.5051 14.7692 13.7499 14.7692ZM13.1538 11.7615H14.3461C14.3589 11.3102 14.4169 10.9753 14.5201 10.7567C14.6233 10.5381 14.8679 10.2423 15.2538 9.8692C15.7153 9.4269 16.0294 9.05318 16.1961 8.74805C16.3627 8.44293 16.4461 8.08845 16.4461 7.6846C16.4461 6.97307 16.1948 6.38621 15.6922 5.92403C15.1897 5.46184 14.5422 5.23075 13.7499 5.23075C13.1307 5.23075 12.5862 5.40158 12.1163 5.74325C11.6464 6.08492 11.3051 6.54357 11.0922 7.1192L12.173 7.57305C12.3422 7.1692 12.5592 6.86632 12.824 6.6644C13.0887 6.46247 13.3974 6.3615 13.7499 6.3615C14.1884 6.3615 14.5486 6.48843 14.8307 6.74228C15.1128 6.99613 15.2538 7.33074 15.2538 7.74613C15.2538 7.99869 15.1823 8.23556 15.0394 8.45673C14.8964 8.67788 14.6487 8.94999 14.2961 9.27308C13.8102 9.69871 13.4983 10.057 13.3605 10.3481C13.2227 10.6391 13.1538 11.1102 13.1538 11.7615ZM8.05765 17.5C7.55252 17.5 7.12496 17.325 6.77498 16.975C6.42498 16.625 6.24998 16.1974 6.24998 15.6923V4.3077C6.24998 3.80257 6.42498 3.375 6.77498 3.025C7.12496 2.675 7.55252 2.5 8.05765 2.5H19.4422C19.9473 2.5 20.3749 2.675 20.7249 3.025C21.0749 3.375 21.2499 3.80257 21.2499 4.3077V15.6923C21.2499 16.1974 21.0749 16.625 20.7249 16.975C20.3749 17.325 19.9473 17.5 19.4422 17.5H8.05765ZM8.05765 16H19.4422C19.5191 16 19.5897 15.9679 19.6538 15.9038C19.7179 15.8397 19.7499 15.7692 19.7499 15.6923V4.3077C19.7499 4.23077 19.7179 4.16024 19.6538 4.09613C19.5897 4.03203 19.5191 3.99998 19.4422 3.99998H8.05765C7.98072 3.99998 7.9102 4.03203 7.8461 4.09613C7.78198 4.16024 7.74993 4.23077 7.74993 4.3077V15.6923C7.74993 15.7692 7.78198 15.8397 7.8461 15.9038C7.9102 15.9679 7.98072 16 8.05765 16ZM4.55768 20.9999C4.05256 20.9999 3.625 20.8249 3.275 20.4749C2.925 20.1249 2.75 19.6973 2.75 19.1922V6.3077H4.24998V19.1922C4.24998 19.2692 4.28202 19.3397 4.34613 19.4038C4.41024 19.4679 4.48076 19.5 4.55768 19.5H17.4422V20.9999H4.55768Z" fill="#62646A"/>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-title>
                FAQ
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              :ripple="false"
              target="_blank"
              href="https://corporategift.com/video-tutorials"
            >
              <v-list-item-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <mask id="mask0_10268_59323" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_10268_59323)">
                    <path d="M12.2504 13.1249L17.6447 9.49994L12.2504 5.87494V13.1249ZM14.8544 18.7307H18.3197C18.271 19.0474 18.1303 19.3227 17.8977 19.5567C17.6648 19.7907 17.3798 19.9294 17.0427 19.9729L5.94093 21.3459C5.4421 21.4063 4.99435 21.2858 4.59768 20.9844C4.20085 20.6833 3.97226 20.2833 3.91193 19.7844L2.65043 9.44994C2.59026 8.95128 2.71493 8.50453 3.02443 8.10969C3.3341 7.71469 3.73826 7.48711 4.23693 7.42694L5.13118 7.33069V8.83069L4.42343 8.91144C4.33376 8.92428 4.26326 8.96278 4.21193 9.02694C4.1606 9.09094 4.14135 9.16786 4.15418 9.25769L5.42743 19.5922C5.44026 19.682 5.47868 19.7525 5.54268 19.8037C5.60685 19.855 5.68376 19.8743 5.77343 19.8614L14.8544 18.7307ZM8.93893 16.7307C8.43376 16.7307 8.00618 16.5557 7.65618 16.2057C7.30618 15.8557 7.13118 15.4281 7.13118 14.9229V4.15369C7.13118 3.64869 7.30618 3.22119 7.65618 2.87119C8.00618 2.52119 8.43376 2.34619 8.93893 2.34619H19.7082C20.2132 2.34619 20.6407 2.52119 20.9907 2.87119C21.3407 3.22119 21.5157 3.64869 21.5157 4.15369V14.9229C21.5157 15.4281 21.3407 15.8557 20.9907 16.2057C20.6407 16.5557 20.2132 16.7307 19.7082 16.7307H8.93893ZM8.93893 15.2307H19.7082C19.7978 15.2307 19.8715 15.2019 19.9292 15.1442C19.987 15.0865 20.0159 15.0128 20.0159 14.9229V4.15369C20.0159 4.06403 19.987 3.99036 19.9292 3.93269C19.8715 3.87503 19.7978 3.84619 19.7082 3.84619H8.93893C8.8491 3.84619 8.77535 3.87503 8.71768 3.93269C8.66001 3.99036 8.63118 4.06403 8.63118 4.15369V14.9229C8.63118 15.0128 8.66001 15.0865 8.71768 15.1442C8.77535 15.2019 8.8491 15.2307 8.93893 15.2307Z" fill="#62646A"/>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-title>
                Video tutorials
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              :ripple="false"
              target="_blank"
              href="https://corporategift.com/blog"
            >
              <v-list-item-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <mask id="mask0_10268_59309" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_10268_59309)">
                    <path d="M4.5 21.5V8.23075C4.5 7.73208 4.67658 7.30617 5.02975 6.953C5.38308 6.59967 5.80908 6.423 6.30775 6.423H13.8365C14.3352 6.423 14.7612 6.59967 15.1145 6.953C15.4677 7.30617 15.6443 7.73208 15.6443 8.23075V21.5L10.077 18.673L4.5 21.5ZM6 19.1865L10.077 17.027L14.1443 19.1865V8.23075C14.1443 8.14108 14.1154 8.06733 14.0577 8.0095C14.0001 7.95183 13.9263 7.923 13.8365 7.923H6.30775C6.21792 7.923 6.14417 7.95183 6.0865 8.0095C6.02883 8.06733 6 8.14108 6 8.23075V19.1865ZM18 17.7212V4.30775C18 4.21792 17.9712 4.14417 17.9135 4.0865C17.8558 4.02883 17.7821 4 17.6923 4H7.39425V2.5H17.6923C18.1909 2.5 18.6169 2.67658 18.9703 3.02975C19.3234 3.38308 19.5 3.80908 19.5 4.30775V17.7212H18Z" fill="#62646A"/>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-title>
                Blog
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              :ripple="false"
              target="_blank"
              href="https://corporategift.com/contact-us"
            >
              <v-list-item-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <mask id="mask0_10268_59317" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_10268_59317)">
                    <path d="M11.25 13.6538V9.2345L9.4 11.0845L8.34625 10L12 6.34625L15.6538 10L14.6 11.0845L12.75 9.2345V13.6538H11.25ZM5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7821 19 18.8558 18.9712 18.9135 18.9135C18.9712 18.8558 19 18.7821 19 18.6923V15.8077H15.7115C15.2757 16.4411 14.7343 16.9327 14.0875 17.2828C13.4407 17.6328 12.7448 17.8077 12 17.8077C11.2552 17.8077 10.5593 17.6328 9.9125 17.2828C9.26567 16.9327 8.72433 16.4411 8.2885 15.8077H5V18.6923C5 18.7821 5.02883 18.8558 5.0865 18.9135C5.14417 18.9712 5.21792 19 5.30775 19ZM12 16.3077C12.6333 16.3077 13.2083 16.1244 13.725 15.7578C14.2417 15.3911 14.6 14.9078 14.8 14.3077H19V5.30775C19 5.21792 18.9712 5.14417 18.9135 5.0865C18.8558 5.02883 18.7821 5 18.6923 5H5.30775C5.21792 5 5.14417 5.02883 5.0865 5.0865C5.02883 5.14417 5 5.21792 5 5.30775V14.3077H9.2C9.4 14.9078 9.75833 15.3911 10.275 15.7578C10.7917 16.1244 11.3667 16.3077 12 16.3077ZM5.30775 19H5H19H5.30775Z" fill="#62646A"/>
                  </g>
                </svg>
              </v-list-item-icon>
              <v-list-item-title>
                Contact us
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import userIsCgElite from '@/mixins/userIsCgElite'

export default {
  name: 'Sidebar',
  mixins: [
    userIsCgElite
  ],
  data: () => ({
    expand: false
  }),
  computed: {
    vendor () {
      const companyId = this.$store.state.header?.headerData?.companyId ?? 0;

      return [4, 5].includes(Number(companyId));
    },
    subAccount () {
      return this.$store.state.header?.headerData?.isSubaccount ?? false
    },
    superAdmin () {
      return this.$store.state.header?.headerData?.isSuperAdmin ?? false
    },
    masterAccount () {
      return this.$store.state.header?.headerData?.isMasterAccount ?? false
    },
    userMenusData () {
      return this.$store.state.header.headerData.menus || {};
    },
    sidebarItems () {
      const { userIsCgElite, vendor, subAccount, superAdmin, masterAccount } = this
      const { myCampaigns, myInventory, myCgCredits, mySubAccounts } = this.userMenusData

      const result = []

      result.push({
        name: 'My account',
        tooltip: 'My Account Dashboard',
        url: { name: 'Dashboard' },
        disabled: false,
        disabledTooltip: null,
        show: true,
        icon: 'IconsSidebarAccount'
      })
      result.push({
        name: 'My orders',
        tooltip: 'My Orders',
        url: { name: 'Orders' },
        disabled: false,
        disabledTooltip: null,
        show: true,
        icon: 'IconsSidebarOrder'
      })
      result.push({
        name: 'My E-Gift orders',
        tooltip: 'My E-Gift Orders',
        url: { name: 'EgiftOrders' },
        href: "/e-gift-orders",
        disabled: false,
        disabledTooltip: null,
        show: true,
        icon: 'IconsSidebarEGiftOrders'
      })
      result.push({
        name: 'CG credits',
        tooltip: 'My CG Credits',
        url: { name: 'MyCGCredits' },
        disabled: false,
        disabledTooltip: null,
        show: !subAccount || myCgCredits,
        icon: 'IconsSidebarCredits'
      })
      result.push({
        name: 'My inventory',
        tooltip: 'My inventory',
        url: { name: 'MyInventory' },
        disabled: vendor,
        disabledTooltip: `View and manage your dedicated gift inventory for eGifting campaigns and
        on-demand fulfillment with the CG Elite gifting platform.`,
        show: myInventory || ((superAdmin || masterAccount) && myInventory),
        icon: 'IconsSidebarInventory'
      })
      result.push({
        name: 'My campaigns',
        tooltip: 'My Campaigns',
        url: { name: 'MyCampaignsPage' },
        disabled: (!myCampaigns && !userIsCgElite) || vendor,
        disabledTooltip: `Create, manage and automate multiple-choice eGift campaigns for various
          occasions and recipient groups with the CG Elite gifting platform.`,
        show: myCampaigns || userIsCgElite,
        icon: 'IconsSidebarOccassions'
      })
      result.push({
        name: 'Manage users',
        tooltip: 'Manage Users',
        url: { name: 'Users' },
        disabled: (!userIsCgElite && !mySubAccounts) || vendor,
        disabledTooltip: `Manage user roles, permissions, budgets and workflows across teams and
          your organization with the CG Elite gifting platform.`,
        show: mySubAccounts || ((superAdmin || masterAccount) && mySubAccounts),
        icon: 'IconsSidebarSubAccount'
      })
      result.push({
        name: 'Contacts',
        tooltip: 'Contacts',
        url: { name: 'Contacts' },
        disabled: false,
        disabledTooltip: null,
        show: true,
        icon: 'IconsSidebarAddressBook'
      })

      return result
    }
  }
}
</script>

<style lang="scss">
.v-navigation-drawer {
  &:not(&--mini-variant) {
    & ~ .v-main > .v-main__wrap > .container,
    & ~ .v-main > .v-main__wrap > .v-sheet > .container {
      padding-left: 64px;
    }
  }
}
</style>

<style lang="scss" scoped>
.common-sidebar {
  z-index: 7;

  @media only screen and (max-width: 565px) {
    display: none;
  }

  .v-list {
    overflow-y: auto;

    & > .v-item-group {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .v-list-item {
      overflow: hidden;

      &__icon {
        margin-top: auto;
        margin-bottom: auto;
        display: flex;
        align-items: center;
        color: #fff;

        & > svg {
          opacity: 0.6;
        }
      }

      &__content {
        color: #fff;
        white-space: nowrap;
      }

      &--disabled {
        & .v-list-item__content {
          color: #95979d;
        }
      }

      &--active {
        background: #555555;
      }

      &:hover {
        .v-list-item__icon > svg {
          opacity: 1;
        }
      }
    }
  }

  &__prepend {
    height: 150px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    padding: 14px 20px;
  }

  &__append {
    margin: 0 0 24px;
  }

  &__append-item {
    overflow: hidden;
    padding: 0 20px;
    cursor: pointer;
    border-radius: 8px;

    & .v-list-item__icon {
      margin-top: auto;
      margin-bottom: auto;
      display: flex;
      align-items: center;
      color: #fff;

      & > svg {
        opacity: 0.6;
      }
    }

    & .v-list-item__content {
      color: #fff;
      white-space: nowrap;
    }

    &:hover .v-list-item__icon > svg {
      opacity: 1;
    }
  }
}
</style>
